module.exports = __webpack_public_path__ + "static/media/ballshark2.cb143512.jpg";